import { create } from "zustand";

interface Resources {
	trc20: number;
	erc20: number;
	trx: number;
	eth: number;
	energy: number;
	maxEnergy: number;
}

interface InitState extends Resources {
	BalanceUpdate: (value: Resources) => void;
}

export const useBalanceStore = create<InitState>((set) => ({
	trc20: 0,
	erc20: 0,
	trx: 0,
	eth: 0,
	energy: 0,
	maxEnergy: 0,
	BalanceUpdate: (value) => {
		set({ ...value });
	},
}));
